import { Publication } from '../../../interfaces/publication';
import { PublicationService } from '../../../services/publication.service';
import { Subscription } from 'rxjs';
import { LocationService } from '../../../services/location.service';
import { AspectRatioService } from 'app/services/aspect-ratio.service';
import { Channel } from '../../../interfaces/channel';
import { Component, Input, ElementRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';

import foundation from '../../../../bbjs/foundation.js';

@Component({
	selector: 'bb-channel',
	templateUrl: './bb-channel.component.html',
	styleUrls: ['./bb-channel.component.scss']
})

export class BbChannelComponent implements AfterViewInit, OnDestroy {

	@Input() channelConfig: Channel;
	@ViewChild('channelTarget') channelTarget: ElementRef;

	private channel: any;
	private subscriptions: Subscription;
	private baseUrl = '';
	private aspectRatios = [];

	constructor(
		private locationService: LocationService,
		private publicationService: PublicationService,
		private aspectRatioService: AspectRatioService
	) {
		this.subscriptions = new Subscription();

		this.subscriptions.add(
			this.publicationService.getData().subscribe((publication: Publication) => {
				if (publication) {
					this.baseUrl = publication.baseurl;
				}
			})
		);

		this.subscriptions.add(this.aspectRatioService.aspectRatiosObs.subscribe(ratios => this.aspectRatios = ratios?.filter(r => !r.default)));
	}

	ngAfterViewInit() {
		const environment = this.locationService.getEnvironment();
		const env = environment && environment.replace(/\s.*$/, ''); // only keep first part
		const foundationOpts = env !== 'prod' ? {
			scriptSrc: 'https://cdn-' + env + '.bluebillywig.com/apps/channel/latest/app.js'
		} : {};
		foundation.loadChannel(foundationOpts, (success: boolean) => {
			this.channel = foundation.createChannel({
				embedData: {
					baseurl: this.baseUrl,
					appId: this.channelConfig.id,
					appIndicator: 'ch'
				},
				appConfig: { ...this.channelConfig, ...{ noStats: true } },
				target: this.channelTarget.nativeElement,
				publicationData: {
					baseurl: this.baseUrl,
					cropsets: this.aspectRatios
				}
			}, (instance: any) => {
				// later maybe
			});
		});
	}

	public updateChannel(config: any) {
		if (this.channel && this.channel.setAppConfig) {
			const newConfig = { ...config, ...{ noStats: true } };
			this.channel.setAppConfig(newConfig);
		}
	}

	ngOnDestroy(): void { }
}
